import React from "react";
import BoxWrapper from "../BoxWrapper";
import Pagination from "../Pagination";
import RenderTable from "../RenderTable";
import ReviewTable from "./tables/RidesReviewsTable";

interface Props {
  data: any;
  isLoading: boolean;
  filters: any;
  onPageChange: (page: number) => void;
  deleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export const RideReviewsTab: React.FC<Props> = ({
  data,
  isLoading,
  filters,
  onPageChange,
  deleteReview,
  isDeletingReview,
}) => {
  return (
    <div className="p-4 border bg-white rounded-4">
      <h2 className="text-xl font-bold mb-4">Avis des Trajets</h2>

      <BoxWrapper>
        <div className="d-flex align-items-center justify-content-end gap-4 mt-5">
          {!isLoading && data?.meta?.totalItems > 0 && (
            <div
              className="d-flex align-items-end bg-gradient-primary p-3 fs-5 fw-bold m-0  text-white mb-2"
              style={{ alignSelf: "flex-end", borderTopRightRadius: "8px" }}
            >
              <span className="me-2">Avis :</span>
              <strong>{data?.meta?.totalItems}</strong>
            </div>
          )}
        </div>

        <RenderTable
          loading={isLoading && !data?.meta?.totalItems}
          render={() => {
            if (isLoading && !data?.meta?.totalItems) return null;
            if (!data?.meta?.totalItems)
              return (
                <p className="text-center fs-5 my-2">Aucun avis trouvé.</p>
              );

            return (
              <ReviewTable
                reviews={data.items}
                deleteReview={deleteReview}
                isDeletingReview={isDeletingReview}
              />
            );
          }}
        />
      </BoxWrapper>

      {data?.meta?.totalPages > 1 && (
        <Pagination
          currentPage={filters.page}
          onPageChange={onPageChange}
          totalCount={data?.meta?.totalPages || 0}
          pageSize={filters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
